import styled from 'styled-components'

export const Container = styled.div`
  .DFpagination {
    padding: 16px 0;
  }
`

export const TabContainer = styled.div`
  display: flex;
  align-items: center;

  li {
    position: relative;
    left: inherit;
    max-width: 100%;
  }
`
export const TabItemContainer = styled.div`
  .tab-item {
    position: relative;
    display: inline;

    .tooltip {
      position: absolute;
      top: -4px;
      right: -24px;
    }
  }
`
